import React from 'react';
import PropTypes from 'prop-types';
import RenderSectionParagraph from '../RenderSectionParagraph/RenderSectionParagraph';
import { MdEmail, MdPhone, MdSupportAgent } from "react-icons/md";
import classes from './SupportSections.module.scss';

const SupportSections = (props) => {
    const { support_block } = props?.data || {};

    if (!support_block?.visible) return null;

    const RenderContact = ({ data, type }) => {
        if (data?.length === 0) return null;

        if (type === 'number') {
            return (<>
                    {data?.map((number, index) => (
                        <div className={classes.ContactLinkWrap} key={`${number}-${index}`}>
                            <MdPhone />
                            <a key={number} href={`tel:${number}`} className={classes.ContactLink}>{number}</a>
                        </div>
                    ))}
                </>)
        }

        if (type === 'email') {
            return (<>
                    {data?.map((email, index) => (
                        <div className={classes.ContactLinkWrap} key={`${email}-${index}`}>
                            <MdEmail />
                            <a key={email} href={`mailto:${email}`} className={classes.ContactLink}>{email}</a>
                        </div>
                    ))}
                </>)
        }
    }

    return (
        <div className={classes.SupportSection}>
            {support_block?.title ? (<h1 className={classes.Title}>
                <MdSupportAgent /> {support_block?.title}
            </h1>) : null}
            {support_block?.subtitle ? (<p className={classes.Subtitle}>{support_block?.subtitle}</p>) : null}
            {support_block?.description?.length !== 0 ? <RenderSectionParagraph data={support_block?.description} /> : null}

            {support_block?.blocks?.length !== 0 ?
                <div className="row">
                    {support_block?.blocks?.map((block, index) => {
                        return (<div className="col-md col-sm-6 mx-auto" key={`${block?.title}-${index}`}>
                            <div className={`${classes.ContactBlock} ${support_block?.blocks?.length === 1 ? classes.NoBorder : ''}`}>
                                {block?.title && <p className={classes.ContactBlock__Title}>{block?.title}</p>}

                                {block?.phones?.length !== 0 ? <RenderContact data={block?.phones || []} type='number' /> : null}
                                {block?.emials?.length !== 0 ? <RenderContact data={block?.emails || []} type='email' /> : null}
                            </div>
                        </div>)
                    })}
                </div>
            : null}

            {/* <div className={classes.ContactBlock}>
                {support_block?.phones?.length !== 0 ? <RenderContact data={support_block?.phones || []} type='number' /> : null}
                {support_block?.emails?.length !== 0 ? <RenderContact data={support_block?.emails || []} type='email' /> : null}
            </div> */}
        </div>
    )
}

SupportSections.propTypes = {}

export default SupportSections;